<template>
  <div v-if="loaded">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1"
              v-model="model.firstname"
              name="fName"
              :label="$t('Firstname')"
              v-validate="{
                regex: '^[َآ-ی_ ]*$',
                required: 'true',
                min: '2',
                max: '150',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('fName')">{{
              errors.first("fName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1"
              v-model="model.lastname"
              name="lName"
              :label="$t('Lastname')"
              v-validate="{
                regex: '^[َآ-ی_ ]*$',
                required: 'true',
                min: '2',
                max: '150',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('lName')">{{
              errors.first("lName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1 left-to-right"
              v-model="model.socialSecurityNumber"
              name="idNumber"
              :label="$t('SocialSecurityNumber')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                digits: '10',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('idNumber')">{{
              errors.first("idNumber")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1 left-to-right"
              v-model="model.birthCertificateNumber"
              name="certificateNumber"
              :label="$t('BirthCertificateNumber')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '1',
                max: '10',
              }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificateNumber')"
              >{{ errors.first("certificateNumber") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1"
              v-model="model.storeName"
              name="store"
              :label="$t('ShopName')"
              v-validate="{
                regex: '^[َآ-ی_ ]*$',
                required: 'true',
                min: '3',
                max: '150',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('store')">{{
              errors.first("store")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1 left-to-right"
              v-model="model.supplierOwnerName"
              name="owner"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '10',
                max: '15',
              }"
              :label="$t('SupplierOwnerNumber') + ' (نام کاربری)'"
            />
            <span class="text-danger text-sm" v-show="errors.has('owner')">{{
              errors.first("owner")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1 left-to-right"
              v-for="phone in model.supplierPhonesCommand"
              :key="phone.id"
              v-model="phone.area"
              name="area"
              :label="$t('PhoneArea')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '3',
                max: '6',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('area')">{{
              errors.first("area")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mt-1 left-to-right"
              v-for="phone in model.supplierPhonesCommand"
              :key="phone.id"
              v-model="phone.number"
              name="number"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                min: '5',
                max: '11',
              }"
              :label="$t('PhoneNumber')"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx"
              v-model="model.emailAddress"
              name="email"
              v-validate="{
                required: 'true',
                email: 'true',
                max: '150',
              }"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label m-0 mt-1">{{ $t("Country") }}</label>
            <v-select
              label="name"
              :options="allCountries"
              name="country"
              :reduce="(x) => ({ countryId: x.id, countryName: x.name })"
              v-validate="{ required: 'true' }"
              ref="countryListSelect"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.supplierCountryInfo"
              @input="selectCountry"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('country')">{{
              errors.first("country")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label m-0 mt-1">{{
              $t("Province")
            }}</label>
            <v-select
              label="name"
              :options="allProvinces"
              name="province"
              :reduce="(x) => ({ provinceId: x.id, provinceName: x.name })"
              v-validate="{ required: 'true' }"
              ref="provinceListSelect"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.supplierProvinceInfo"
              @input="selectProvince"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('province')">{{
              errors.first("province")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label m-0 mt-1">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="city"
              :options="allCities"
              :reduce="(x) => ({ cityId: x.id, cityName: x.name })"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.supplierCityInfo"
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityListSelect"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{
              errors.first("city")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx left-to-right"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.postalCode"
              name="postalCode"
              v-validate="{
                required: 'true',
                regex: '^([0-9]+)$',
                digits: '10',
              }"
              :label="$t('PostalCode')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('postalCode')"
              >{{ errors.first("postalCode") }}</span
            >
          </div>
          <span class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("EconomicCode") }}</label>
            <div
              class="vx-row w-full p-0 mx-0 vs-input--input vs-input--input.normal"
            >
              <vs-input
                class="vs-input-no-border w-1/3 left-to-right"
                v-model="economicCodeSpecific"
                name="economicCode"
                maxlength="4"
                placeholder="کد اقتصادی"
                v-validate="{
                  regex: '^([0-9]+)$',
                  required: 'true',
                  digits: '4',
                }"
              />
              <vs-input
                class="vs-input-no-border w-2/3"
                v-model="model.socialSecurityNumber"
                name="socialSecurityNumber"
                disabled
              />
            </div>
            <span
              class="text-danger text-sm"
              v-show="errors.has('economicCode')"
              >{{ errors.first("economicCode") }}</span
            >
          </span>
          <div class="vx-col lg:w-2/4 md:w-2/3 sm:2/3 w-full">
            <vs-input
              class="inputx"
              v-for="address in model.addressesInfoCommand"
              :key="address.id"
              v-model="address.address"
              name="address"
              :label="$t('Address')"
              v-validate="{
                required: 'true',
                min: '3',
                max: '500',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')">{{
              errors.first("address")
            }}</span>
          </div>
          <div class="vx-row vx-col m-2">
            <vs-checkbox
              @click="setForeignSubjects($event)"
              :checked="model.individualSupplierTaxInfo.isForeignSubjects"
              class="px-3"
              >{{ $t("NotIranianCitizen") }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-3">
      <div class="vx-card__header">
        <div class="vx-card__title">
          <h4>{{ $t("TaxInfo") }}</h4>
        </div>
      </div>
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvincesOfTadbir"
              name="provinceOfTadbir"
              :reduce="(x) => x.id"
              v-validate="{ required: 'true' }"
              ref="provinceListSelect"
              v-model="model.individualSupplierTaxInfo.provinceId"
              @input="selectProvinceOfTadbir"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('provinceOfTadbir')"
              >{{ errors.first("provinceOfTadbir") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label m-0 mt-1">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="cityOfTadbir"
              :options="allCitiesOfTadbir"
              :reduce="(x) => x.id"
              v-model="model.individualSupplierTaxInfo.cityId"
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityOfTadbirListSelect"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('cityOfTadbir')"
              >{{ errors.first("cityOfTadbir") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/2 md:w-1/3 w-full">
            <vs-button
              type="filled"
              class="float-right submit-btn mt-4 md:w-auto w-full"
              @click.prevent="submitForm()"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .submit-btn:focus {
  color: #fff !important;
}
::v-deep .vs-con-input .vs-inputx {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
::v-deep .text-danger {
  top: 0 !important;
}
::v-deep .left-to-right input {
  direction: ltr;
  text-align: right;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    fName: {
      required: "لطفا نام را وارد نمایید.",
      regex: "نام وارد شده معتبر نیست.",
      max: "نام وارد شده معتبر نیست.",
      min: "نام وارد شده معتبر نیست.",
    },
    lName: {
      required: "لطفا نام خانوادگی را وارد نمایید.",
      regex: "نام خانوادگی وارد شده معتبر نیست.",
      max: "نام خانوادگی وارد شده معتبر نیست.",
      min: "نام خانوادگی وارد شده معتبر نیست.",
    },
    idNumber: {
      required: "لطفا کدملی را وارد نمایید.",
      regex: "کدملی وارد شده معتبر نیست.",
      digits: "کدملی وارد شده معتبر نیست.",
    },
    economicCode: {
      required: "لطفا شماره اقتصادی را وارد نمایید.",
      regex: "شماره اقتصادی وارد شده معتبر نیست.",
      digits: "شماره اقتصادی وارد شده معتبر نیست.",
    },
    certificateNumber: {
      required: "لطفا شماره شناسنامه را وارد نمایید.",
      regex: "شماره شناسنامه وارد شده معتبر نیست.",
    },
    store: {
      required: "لطفا نام مغازه را وارد نمایید.",
      regex: "نام مغازه وارد شده معتبر نیست.",
      max: "نام مغازه وارد شده معتبر نیست.",
      min: "نام مغازه وارد شده معتبر نیست.",
    },
    owner: {
      required: "لطفا  اصلی را وارد نمایید.",
      regex: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      max: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      min: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
    },
    area: {
      required: "لطفا پیش شماره را وارد نمایید.",
      regex: "پیش شماره وارد شده معتبر نیست.",
      max: "پیش شماره وارد شده معتبر نیست.",
      min: "پیش شماره وارد شده معتبر نیست.",
    },
    number: {
      required: "لطفا شماره تلفن را وارد نمایید.",
      regex: "شماره تلفن وارد شده معتبر نیست.",
      max: "شماره تلفن وارد شده معتبر نیست.",
      min: "شماره تلفن وارد شده معتبر نیست.",
    },
    email: {
      required: "لطفا پست الکترونیک را وارد نمایید.",
      email: "پست الکترونیک وارد شده معتبر نیست.",
      max: "پست الکترونیک وارد شده معتبر نیست.",
    },
    country: {
      required: "لطفا کشور را انتخاب نمایید.",
    },
    province: {
      required: "لطفا استان را انتخاب نمایید.",
    },
    city: {
      required: "لطفا شهر را انتخاب نمایید.",
    },
    postalCode: {
      required: "لطفا کدپستی را وارد نمایید.",
      regex: "کدپستی وارد شده معتبر نیست.",
      digits: "کدپستی وارد شده معتبر نیست.",
    },
    address: {
      required: "لطفا آدرس را وارد نمایید.",
      max: "آدرس وارد شده معتبر نیست.",
      min: "آدرس وارد شده معتبر نیست.",
    },
    provinceOfTadbir: {
      required: "لطفا استان را در قمست مشخصات مالیاتی انتخاب نمایید.",
    },
    cityOfTadbir: {
      required: "لطفا شهر را در قمست مشخصات مالیاتی انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      economicCodeSpecific: "",
      model: {
        firstname: null,
        lastname: null,
        socialSecurityNumber: null,
        birthCertificateNumber: null,
        storeName: "",
        emailAddress: "",
        supplierOwnerName: "",
        addressesInfoCommand: [
          {
            supplierProvinceInfo: {
              provinceId: null,
              provinceName: "",
            },
            supplierCityInfo: {
              cityId: null,
              cityName: "",
            },
            address: "",
            postalCode: "",
          },
        ],
        supplierPhonesCommand: [
          {
            area: "",
            number: "",
          },
        ],
        individualSupplierTaxInfo: {
          isForeignSubjects: false,
          provinceId: null,
          cityId: null,
        },
      },
      disabled: false,
      loaded: false,
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provincesByIdList",
      allCountries: "country/countryList",
      allProvincesOfTadbir: "country/provinceOfTadbirList",
      allCities: "country/cityList",
      allCitiesOfTadbir: "country/cityOfTadbirList",
    }),
  },
  methods: {
    ...mapActions({
      createSupplier: "individual/createSupplier",
      fetchProvinces: "country/fetchProvinces",
      fetchCountry: "country/fetchCountry",
      fetchCitiesById: "country/fetchCitiesById",
      fetchProvincesById: "country/fetchProvincesById",
      fetchProvincesOfTadbir: "country/fetchProvincesOfTadbir",
      fetchCitiesOfTadbirById: "country/fetchCitiesOfTadbirById",
    }),
    load() {
      this.fetchProvinces().then(() => {
        this.fetchCountry().then(() => {
          this.fetchProvincesOfTadbir().then(() => {
            this.loaded=true
          });
        });
      });
    },
    selectProvince(province) {
      this.fetchCitiesById(province.provinceId);
      this.model.addressesInfoCommand[0].supplierCityInfo={}

    },
    selectCountry(country) {
      this.fetchProvincesById(country.countryId);
      this.model.addressesInfoCommand[0].supplierProvinceInfo={}
      this.model.addressesInfoCommand[0].supplierCityInfo={}
    },
    selectProvinceOfTadbir(provinceOfTadbir) {
      this.fetchCitiesOfTadbirById(provinceOfTadbir);
      console.log(this.$refs.cityOfTadbirListSelect)

      if (this.$refs.cityOfTadbirListSelect) {
        this.$refs.cityOfTadbirListSelect.clearSelection();
      }
    },
    setForeignSubjects(val) {
      if (val.target.checked) this.model.isForeignSubjects = true;
      else this.model.isForeignSubjects = false;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.model.isForeignSubjects !== true) {
            this.model.isForeignSubjects = false;
          }
          this.disabled = true;
          this.model.economicCode = this.model.socialSecurityNumber.concat(
            this.economicCodeSpecific
          );
          this.createSupplier(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.$router.push("/Suppliers/Index");
              });
              this.$validator.reset();
            })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          // form have errors
        }
      });
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
